import FirebaseRead from "@/services/database/firebaseRead";
import FirebaseWrite from "@/services/database/firebaseWrite";
import TimeStamp from "@/services/timeStamp";
import EXCEL_DOWNLOAD from '@/utilities/services/downloads/excel/excelDownload';
import {db} from "@/services/db";

export class KugelPaesseService {
    constructor() {
        this.passList = []
        this.filter = {
            show: 'pending', // pending, history, export
            from: '',
            until: '',
            fromTs: 0,
            untilTs: 0,
            error: '',
        // export
            sportart: 'classic',
            allOrTimeframe: true,
        }
        this.setPendingPassList()
    }

    async setPendingPassList(){
        if ( this.filter.show === 'pending' ) {
            this.passList = await FirebaseRead.readDocList('kugeln', {
                field: 'waitingForPassPrint', operator: '==', value: true
            })
        } else if ( this.filter.show === 'history' ) {
            this.setHistoryDates(false)
            if ( this.filter.error ) { this.passList = []; return}
            const passList = await FirebaseRead.readDocListDouble('kugeln', [{
                field: 'tsLastPassPrint', operator: '>=', value: this.filter.fromTs
            },{
                field: 'tsLastPassPrint', operator: '<=', value: this.filter.untilTs
            }])
            this.passList = passList.filter(pass => !pass.waitingForPassPrint)
        }
        this.passList = this.passList.map((kugelPass)=>(
            {...kugelPass, selected: false}))
    }

    setSelected(value){
        this.passList.forEach( (item) => {
            item.selected = value
        });
    }

    setHistoryDates(init){
        this.filter.error = ''
        if ( this.filter.show === 'pending' ) return
        if ( init ) {
            const today = TimeStamp.getTodayString()
            this.filter.untilTs = TimeStamp.getTimestampForDate( 'until', today)
            this.filter.until = today
            this.filter.fromTs = this.filter.untilTs - 7*24*60*60*1000
            this.filter.from = TimeStamp.getDateForTimestamp('', this.filter.fromTs)
        } else {
            this.filter.fromTs = TimeStamp.getTimestampForDate( '', this.filter.from)
            this.filter.untilTs = TimeStamp.getTimestampForDate( 'until', this.filter.until)
        }
        if ( this.filter.fromTs > this.filter.untilTs ) this.filter.error = "Das 'von'-Datum muss kleiner sein als das 'bis'-Datum!"
        if ( this.filter.untilTs - this.filter.fromTs > 30*24*60*60*1000 &&
             this.filter.show !== 'export') this.filter.error = "Die Zeitspanne darf maximal 30 Tage betragen!"
    }

    removeItem(pass){
        pass.selected = false
    }

    getPrintList(){
        return this.passList.filter(pass => pass.selected);
    }

    showDateFilter(){
        return this.filter.show === 'history' ||
            (this.filter.show === 'export' && !this.filter.allOrTimeframe)
    }

    changePrintStatus(item){
        const i = this.passList.findIndex( kugel => kugel.id === item.id)
        this.passList.splice(i,1)
    }

    async processPrint(){
        const promiseList = this.createPromiseList()
        await Promise.all(promiseList)
        this.passList = []
        this.setPendingPassList();
    }

        createPromiseList(){
            const promiseList = []
            this.passList.filter(pass => pass.selected).forEach( (kugel) => {
                const p = FirebaseWrite.update('kugeln', kugel.id, {
                    waitingForPassPrint: false,
                    tsLastPassPrint: TimeStamp.getGMTTimestamp()
                })
                promiseList.push(p)
            });
            return promiseList
        }

    async exportToExcel(){
        const passList = await this.getDataForExport()
        if ( passList === 'error' ) return -1
        EXCEL_DOWNLOAD.exportJsonToSingleSheet(
            passList,
            'Kugelpässe_'+this.filter.sportart,
            TimeStamp.getTodayString(),
            this.getExcelHeaderConfig(),
        );
        return passList.length
    }

        async getDataForExport(){
            let passListData = null
            if ( this.filter.allOrTimeframe ) {
                passListData = await db.collection('kugeln')
                    .where('sportart', '==', this.filter.sportart).get()
            } else {
                this.setHistoryDates(false)
                if ( this.filter.error !== '' ) return 'error'
                passListData = await db.collection('kugeln')
                    .where('sportart', '==', this.filter.sportart)
                    .where('tsLastPassPrint', '>=', this.filter.fromTs)
                    .where('tsLastPassPrint', '<=', this.filter.untilTs)
                    .get()
            }
            let passList = [];
            passListData.forEach((doc) => {
                let document = doc.data();
                document.id = doc.id;
                document.tsCreated = TimeStamp.getLocalDateAndTime(document.tsCreated)
                document.tsLastUpdated = document.tsLastUpdated === 0 ? '-' : TimeStamp.getLocalDateAndTime(document.tsLastUpdated)
                document.tsLastPassPrint = document.tsLastPassPrint === 0 ? '-' : TimeStamp.getLocalDateAndTime(document.tsLastPassPrint)
                document.waitingForPassPrint = document.waitingForPassPrint ? 'ja' : 'nein'
                document.sportart = document.sportart.charAt(0).toUpperCase()  + document.sportart.slice(1)
                document.ownerType = document.ownerType.charAt(0).toUpperCase()  + document.ownerType.slice(1)
                passList.push(document);
            });
            return passList
        }
        getExcelHeaderConfig(){
            return [
                { text: 'KugelNr', value: 'nr' },
                { text: 'Besitzer-Typ', value: 'ownerType' },
                { text: 'Besitzer', value: 'ownerName' },
                { text: 'Geburtsdatum', value: 'geburtsdatum' },
                { text: 'Gültig bis', value: 'gueltigBis' },
                { text: 'Kommentar', value: 'kommentar' },
                { text: 'Sportart', value: 'sportart' },
                { text: 'Erstellt am', value: 'tsCreated' },
                { text: 'Erstellt von', value: 'createdByName' },
                { text: 'Zuletzt geändert am', value: 'tsLastUpdated' },
                { text: 'Zuletzt geändert von', value: 'lastUpdatedByName' },
                { text: 'Zuletzt gedruckt am', value: 'tsLastPassPrint' },
                { text: 'Wartet auf Druck', value: 'waitingForPassPrint' },
            ]
        }

}